import { useContext, useEffect, useMemo, useState } from "react";
import { ModalSettingContext } from "../../../../index";
import s from './index.module.css';
import { CollapsePanel } from "../../../CollapsePanel";
import { Switch } from 'antd';
import { InputWhite, TextareaWhite } from "@UI/New/InputWhite";
import useLoad from "@/hooks/useLoad";
import { directionAPI } from "@/api";
import { selectLessons } from "@/helpers/selectLessons";
import { compareOptionsByLabel } from "@/helpers/new/compareOptionsByLabel";
import Select from "@UI/New/Select";

export const CommentToDzAndLessonTotic = () => {
    const { state, setFieldInState } = useContext(ModalSettingContext);
    const [manualEntry, setManualEntry] = useState(false);

    const { state: themes, getState: getThemes, setState: setThemes, loading: themesLoading } = useLoad({
        api: directionAPI.get,
        params: { id: state.direction, expand: ['directionCourses.material.topicLesson'] },
        initState: {},
        last: false
    })

    const [selectedLessonId, setSelectedLessonId] = useState(null);

    useEffect(()=>{
        if(!state.direction) {
            setThemes({})
            setSelectedLessonId(null)
            queueMicrotask(() => {
                setFieldInState({ field: 'lesson_topic', value: '' });
            });
            return;
        }
        getThemes();
    }, [state.direction])

    const listLessons = useMemo(() => selectLessons(themes), [themes]);

    const toggleSelectedLesson = (idInList) => {
        setSelectedLessonId(idInList)
        const themeName = listLessons.find((el) => el.value == idInList)?.label ?? '';
        setFieldInState({field: 'lesson_topic', value: themeName})
    }

    const fieldsSeminarian = {
        loading: themesLoading,
        showSearch: true,
        allowClear: true,
        filterSort: compareOptionsByLabel,
        filterOption: true,
        onChange: toggleSelectedLesson,
        options: listLessons,
        value: selectedLessonId,
        placeholder: 'Тема занятия',
        notFoundContent: !state.direction
            ? "Выберите курс" 
            : "Темы не найдены" 
    };

    return (
       <CollapsePanel header="Выбор темы и комментария к ДЗ из КТП">
            <div className={s.wrapper}>
                    <Switch
                        checked={manualEntry}
                        onChange={() => {
                            setManualEntry((prev)=>{
                                if(prev){
                                    setFieldInState({field: 'lesson_topic', value: ''})
                                    setSelectedLessonId(null)
                                }
                                
                                return !prev;
                            })
                        }}
                    />
                    <span className={s.text}>Ввести тему и комментарий к ДЗ в ручную и добавить к КТП</span>
            </div>
           
            {
                !manualEntry && (
                    <Select 
                        wrapperClassName={s.wrapperSelect} 
                        className={s.select} 
                        fields={fieldsSeminarian} 
                    />
                )
            }
            {
                manualEntry && (
                    <InputWhite 
                        value={state.lesson_topic}
                        placeholder='Введите тему'
                        onChange={value => setFieldInState({field: 'lesson_topic', value})}
                        className={s.input}
                    />
                )
            }
            
            <TextareaWhite 
                value={state.comment_to_dz}
                placeholder='Введите комментарий'
                onChange={value => setFieldInState({field: 'comment_to_dz', value})}
                className={s.textarea}
            />
       </CollapsePanel>
    )
}
